import React, { Component } from 'react'
import { apiProcess } from '../../../api/api'
import { WORLD_COUNTRIES } from '../../../../constants'
import {
  trackPhoneChange,
  trackPhoneChangeAttempt,
  trackPhoneVerifiedAttempt,
  trackPhoneVerified,
} from '../../../elements/tracking/accountTracking.js'
import { Button, Field, Header } from '../../../elements'
import './phoneScreen.css'
import { PHONE } from 'components/account/infoWizard/main/constants'
import {
  updateKlaviyoPhoneNumber,
  subscribeUserPhone,
  trackUserChangedPhoneNumber,
} from './../../../elements/klaviyoTracking/editUserProfile'

var findKey = require('lodash/findKey')

class PhoneScreen extends Component {
  constructor(props) {
    super(props)
    document.body.classList.add('phone-info-signup-screen')

    this.state = {
      phoneNumber: '',
      phoneNumberError: false,
      phoneCountryCodeAlpha: 'US',
      phoneCountryCodeNum: '+1',
      phoneVerfCode: '',
      phoneVerfError: false,
      phoneVerfLoading: false,
      phoneLoading: false,
      smsSent: false,
      generalError: false,
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(PHONE)
  }

  componentWillUnmount() {
    document.body.classList.remove('phone-info-signup-screen')
  }

  handlePhoneCodeChange = (phoneCodeAlpha) => {
    const countryDataKey = findKey(WORLD_COUNTRIES, ['value', phoneCodeAlpha])

    const phoneCountryCodeNum = WORLD_COUNTRIES[countryDataKey].phoneCode

    this.setState({
      phoneCountryCodeAlpha: phoneCodeAlpha,
      phoneCountryCodeNum: phoneCountryCodeNum,
    })
  }

  saveNumberSendSMS = () => {
    if (this.state.phoneNumber === '') {
      this.setState({
        phoneNumberError: 'Phone number is required.',
      })
      this.props.onAttempt({
        error_message: 'Phone number is required.',
        attempt_desc: 'Save Phone Number',
        error_code: 'UI',
        error_type: 'UI',
      })
      trackPhoneChangeAttempt({
        phone: this.state.phoneNumber,
        error_message: 'Phone number is required.',
        error_code: 'UI',
        error_type: 'UI',
        parent: this.props.parentDescription,
      })

      return false
    }

    this.setState({
      phoneLoading: true,
      phoneNumberError: false,
      phoneVerfError: false,
      generalError: false,
    })

    let apiURL = 'users/validations/send_phone_token'

    let phoneData = {
      phone_number: this.state.phoneCountryCodeNum + this.state.phoneNumber,
    }

    apiProcess(
      apiURL,
      phoneData,
      'send-phone-verf-sms',
      'Save Phone Number - Phone Verf'
    )
      .then((responseData) => {
        this.setState({
          smsSent: true,
          phoneLoading: false,
        })
        trackPhoneChange({
          phone: phoneData.phone_number,
          parent: this.props.parentDescription,
        })
      })
      .catch((responseData) => {
        let phoneNumberError = null

        if (responseData?.errorResponseData && responseData?.errorResponseData.hasOwnProperty('errors')) {
          if (responseData.errorResponseData.errors.length > 0) {
            phoneNumberError = responseData.errorResponseData.error_messages[0]
          }
        } else {
          phoneNumberError = 'We are having issues right now. Please try again.'
        }

        this.props.onAttempt({
          attempt_desc: 'Save Phone Number',
          error_message: phoneNumberError,
          error_code: responseData.code,
          error_type: 'Submission - Server',
        })
        trackPhoneChangeAttempt({
          phone: this.state.phoneNumber,
          error_message: phoneNumberError,
          error_code: responseData.code,
          error_type: 'Submission - Server',
          parent: this.props.parentDescription,
        })

        this.setState({
          phoneNumberError,
          phoneLoading: false,
        })
      })
  }

  changeNumber = () => {
    this.setState({
      smsSent: false,
    })
  }

  handleVerfCode = (verfCode) => {
    this.setState({
      phoneVerfCode: verfCode,
      phoneVerfError: false,
    })

    if (verfCode.length === 4) {
      this.setState({
        phoneVerfLoading: true,
      })

      let apiURL = 'users/validations/validate_phone_token'

      let codeData = {
        verification_code: verfCode,
      }
      apiProcess(apiURL, codeData, 'validate-phone-token', 'Verify SMS Code')
        .then((responseData) => {
          //alert('success')
          this.setState({
            phoneVerfLoading: false,
          })
          trackPhoneVerified({
            parent: this.props.parentDescription,
          })
          this.props.onSuccess()
          this.props.embeddedSuccess(this.state.phoneNumber)
          updateKlaviyoPhoneNumber(this.state.phoneCountryCodeNum + this.state.phoneNumber)
          subscribeUserPhone(this.state.phoneCountryCodeNum + this.state.phoneNumber)
          trackUserChangedPhoneNumber(this.state.phoneNumber)
        })
        .catch((responseData) => {
          if (responseData.errorResponseData.hasOwnProperty('errors')) {
            if (responseData.errorResponseData.errors.length > 0) {
              this.setState({
                phoneVerfError:
                  responseData.errorResponseData.error_messages[0],
                phoneVerfLoading: false,
              })
              this.props.onAttempt({
                attempt_desc: 'Save Phone Number',
                error_message: responseData.errorResponseData.error_messages[0],
                error_code: responseData.code,
                error_type: 'Submission - Server',
              })
              trackPhoneVerifiedAttempt({
                phone: this.state.phoneNumber,
                code: verfCode,
                parent: this.props.parentDescription,
                error_message: responseData.errorResponseData.error_messages[0],
                error_code: responseData.code,
                error_type: 'Submission - Server',
              })
            }
          } else {
            this.setState({
              phoneVerfError:
                'We are having issues right now. Please try again.',
              phoneVerfLoading: false,
            })
            this.props.onAttempt({
              attempt_desc: 'Save Phone Number',
              error_message:
                'We are having issues right now. Please try again.',
              error_code: responseData.code,
              error_type: 'Submission - Server',
            })
            trackPhoneVerifiedAttempt({
              phone: this.state.phoneNumber,
              code: verfCode,
              parent: this.props.parentDescription,
              error_message:
                'We are having issues right now. Please try again.',
              error_code: responseData.code,
              error_type: 'Submission - Server',
            })
          }
        })
    }
  }

  render() {
    const {
      generalError,
      phoneNumber,
      phoneNumberError,
      phoneCountryCodeAlpha,
      phoneCountryCodeNum,
      phoneVerfCode,
      phoneVerfLoading,
      phoneVerfError,
      phoneLoading,
      smsSent,
    } = this.state

    const { header, instructions, fullWidthCTA } = this.props

    return (
      <React.Fragment>
        {!smsSent && (
          <div>
            {header && (
              <Header
                renderas="h2"
                size={4}
                className="has-text-weight-bold mb-4 mt-5"
              >
                {header}
              </Header>
            )}
            {instructions && <p className="mb-4">{instructions}</p>}
            {generalError && (
              <div className="has-text-danger mb-4">{generalError}</div>
            )}
            {/*(icon && (
                <span className="icon is-medium">
                  <span className="fa-stack fa-3x">
                    <i className="fal fa-circle fa-stack-2x"></i>
                    <i className="fal fa-phone fa-stack-1x"></i>
                  </span>
                </span>
            )*/}

            <Field
              placeholder="Select Country"
              fullwidth
              options={WORLD_COUNTRIES}
              name="country"
              id="country"
              type="select"
              error={phoneNumberError}
              value={phoneCountryCodeAlpha}
              onChange={({ value }) => this.handlePhoneCodeChange(value)}
              showErrors={false}
            />

            <p className="is-size-6 has-text-grey field">
              <strong>
                * NOTE: We do not accept VOIP or virtual numbers, such as
                Cricket, Google Voice or others.
              </strong>
            </p>

            <Field
              hasAddOns={true}
              leftAddOn={
                <button className="button is-static is-white">
                  {phoneCountryCodeNum}
                </button>
              }
              type="input"
              fullwidth
              error={phoneNumberError}
              placeholder="Enter Phone Number"
              value={phoneNumber}
              onChange={({ value }) =>
                this.setState((state) => {
                  state.phoneNumber = value
                  state.phoneNumberError = null
                  return state
                })
              }
              showErrors={false}
            />

            {phoneNumberError && (
              <div
                className="has-text-danger is-size-7 has-text-left mt-0 mb-4"
                style={{ marginTop: '-1rem' }}
              >
                {phoneNumberError}
              </div>
            )}

            <p className="is-size-7 has-text-grey">
              I agree to receive transactional and/or operational text messages from time to time regarding my rental requests
              from Twisted Road at the number I provided. Msg & data rates may apply. Reply STOP to no longer receive messages.
              View our  <a href="/terms-conditions" target='_blank'>Terms of Service</a> and <a href="/privacy-policy" target='_blank'>Privacy Policies</a>.
            </p>

            <Button
              disabled={phoneLoading}
              loading={phoneLoading}
              className="confirm-phone-number-button"
              color="primary"
              size="medium"
              fullwidth={fullWidthCTA.toString()}
              onClick={() => this.saveNumberSendSMS()}
            >
              Confirm Phone Number
            </Button>
          </div>
        )}

        {smsSent && (
          <div
            className={
              this.props.centeredVerfCTA ? 'has-text-centered' : 'has-text-left'
            }
          >
            <Header
              renderas="h2"
              size={4}
              className="has-text-weight-bold mb-4 mt-5"
            >
              Enter 4-digit code
            </Header>
            <p className="mb-4">
              We sent an SMS to {phoneNumber} with your code.
            </p>
            {generalError && (
              <div className="has-text-danger mb-4">{generalError}</div>
            )}

            <Field
              inputClassName={
                this.props.centeredVerfCTA
                  ? 'has-text-centered phone-verf-input m-center'
                  : 'phone-verf-input'
              }
              error={phoneVerfError}
              placeholder="X - X - X - X"
              value={phoneVerfCode}
              size="medium"
              name="phoneVerf"
              id="phoneVerf"
              type="input"
              loading={phoneVerfLoading}
              onChange={({ value }) => this.handleVerfCode(value)}
              showErrors={false}
            />
            {phoneVerfError && (
              <div
                className="has-text-danger has-text-centered is-size-7 mt-0 mb-4 m-center"
                style={{ marginTop: '-1rem' }}
              >
                {phoneVerfError}
              </div>
            )}

            <div
              className={
                this.props.centeredVerfCTA
                  ? 'has-text-centered mt-5'
                  : 'has-text-left mt-5'
              }
            >
              {phoneNumberError && (
                <div
                  className="has-text-danger has-text-centered is-size-7 mt-0 mb-4 m-center"
                  style={{ marginTop: '-1rem' }}
                >
                  {phoneNumberError}
                </div>
              )}
              <Button
                disabled={phoneLoading}
                loading={phoneLoading}
                size="small"
                className={'mb-4'}
                onClick={() => this.saveNumberSendSMS()}
              >
                Send Code Again
              </Button>
              <br />
              {!phoneLoading && (
                <Button size="small" onClick={() => this.changeNumber()}>
                  Change Number
                </Button>
              )}
            </div>
          </div>
        )}

        {this.props.skippable && (
          <span
            className="is-block has-text-centered is-size-7 mt-1 is-clickable mt-2 finger-pointer"
            onClick={() => this.props.onSuccess()}
          >
            I'll do this later
          </span>
        )}
      </React.Fragment>
    )
  }
}

export default PhoneScreen

PhoneScreen.defaultProps = {
  onSuccess: function () { },
  onAttempt: function () { },
  embeddedSuccess: function () { },
  skippable: true,
  header: 'Verify your phone number',
  instructions:
    'This is so owners, your riders, and Twisted Road can contact you.',
  icon: true,
  parentDescription: 'Missing',
  onScreenLoad: function () { },
  fullWidthCTA: true,
  centeredVerfCTA: true,
}
